import * as yup from 'yup';
import YupPassword from 'yup-password';
import { PASSWORD_MIN_ERROR, PASSWORD_REQUIRED_ERROR, PASSWORD_RULES_ERROR } from '../SignUp';
YupPassword(yup);
export const updatePasswordInitialValues = {
  newPassword: '',
  oldPassword: '',
  repNewPassword: ''
};
export const resetPasswordSetSchema = yup.object({
  newPassword: yup.string().trim().minUppercase(1, PASSWORD_RULES_ERROR).minLowercase(1, PASSWORD_RULES_ERROR).minNumbers(1, PASSWORD_RULES_ERROR).minSymbols(1, PASSWORD_RULES_ERROR).min(8, PASSWORD_MIN_ERROR).required(PASSWORD_REQUIRED_ERROR),
  oldPassword: yup.string().trim().minUppercase(1, PASSWORD_RULES_ERROR).minLowercase(1, PASSWORD_RULES_ERROR).minNumbers(1, PASSWORD_RULES_ERROR).minSymbols(1, PASSWORD_RULES_ERROR).min(8, PASSWORD_MIN_ERROR).required(PASSWORD_REQUIRED_ERROR),
  repNewPassword: yup.string().trim().oneOf([yup.ref('newPassword'), null]).required()
});